import { AttendanceCustomPeriodEmployeeItemFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

interface Status {
  label: string
  text: string
  variant: 'positive' | 'neutral' | 'warning'
}

export const useEmployeeStatus = (employee: AttendanceCustomPeriodEmployeeItemFragment): Status => {
  if (employee.reviewStatus === 'approved') {
    return {
      label: i18n.t('time_tracking.table_collection.employee_summary.status.approved'),
      text: i18n.t('time_tracking.table_collection.employee_summary.status.approved'),
      variant: 'positive',
    }
  } else if (employee.reviewStatus === 'pending') {
    return {
      label: i18n.t('time_tracking.table_collection.employee_summary.status.pending'),
      text: i18n.t('time_tracking.table_collection.employee_summary.status.pending'),
      variant: 'warning',
    }
  }
  return {
    label: i18n.t('time_tracking.table_collection.employee_summary.status.in_progress'),
    text: i18n.t('time_tracking.table_collection.employee_summary.status.in_progress'),
    variant: 'neutral',
  }
}
